<template>
    <div class='container main-app'>
        <div class='main-bg-image' :style="{backgroundImage: 'url(' + thumbnail + ')' }" v-if="!$mobile"></div>
        <div class='main-bg-cover'></div>
        
        <div class='desktop-view' v-show="$mobile && orientation === 'landscape' || !$mobile">
        
            <transition name="popup" mode="out-in">
                <Carousel v-if="$store.state.carousel.show"></Carousel>
            </transition>
            
            
            <transition name="slide-fade" mode="out-in">
                <router-view></router-view>
            </transition>

            <div class='vignette'></div>
        </div>
        <div class='mobile-view' v-show="$mobile && orientation === 'portrait'">
            <div class='mobile-warning'>
                <!--<span></span>
                Kantel het scherm om deze site te<br>bekijken op een mobiel apparaat-->
            </div>
        </div>
</div>
</template>

<script>
    import { sync } from 'vuex-router-sync'
    import store from './services/store'
    import router from './services/router'

    import Carousel from './components/Carousel'

    import { episodes } from './data'

    sync(store, router)

    export default {
        name: 'App',
        components: {
            Carousel
        },
        data: () => ({
            orientation: ''
        }),
        mounted () {
            window.unlockallthethings = () => {
                this.$store.dispatch('ENABLE_DEBUGMODE')
            }
            this.$store.dispatch('UNLOCK_EPISODE', { episode: 0 })
            if (!this.$mobile) {
                this.animateBG()
            }
            this.checkMobile();
            window.addEventListener('orientationchange', () => {
                this.$nextTick(() => {
                    this.checkOrientation()
                })
            })
            this.$nextTick(() => {
                this.checkOrientation()
            })
        },
        computed: {
            thumbnail: {
                get () {
                    return episodes[this.$store.state.game.episode].thumbnail
                }
            }
        },
        methods: {
            checkOrientation () {
                this.orientation = ''
                setTimeout(() => {
                    this.orientation = (window.innerHeight < window.innerWidth) ? 'landscape' : 'portrait'
                }, 300)
            },
            animateBG(){
                TweenLite.set('.main-bg-cover', {z:100, opacity:0.9});
                TweenLite.set('.main-bg-image', {z:-100});
                TweenLite.to ('.main-bg-image', 60, {delay: 20, scale:1.05, x:15, y: -15, ease:"bg-wiggle", onComplete: () => {
                    this.animateBG();
                }})
            },

            checkMobile(){
                // if (/Android|webOS|iPhone|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
                //     $('.desktop-view').css('display', 'none')
                //     $('.mobile-view').css('display', 'block')
                // } else {
                //     $('.desktop-view').css('display', 'block')
                //     $('.mobile-view').css('display', 'none')
                // }
            }
        },
        store,
        router
    }
</script>



// WEBPACK FOOTER //
// App.vue?50811596